// extracted by mini-css-extract-plugin
export default {"watsappButton":"WatsappButton_watsappButton__2hKrI"};